<primary-navbar *ngIf="!(existPendingOperations$ | async)"></primary-navbar>

<div id="page-container">
  <main id="content" class="bg-light">
    <router-outlet></router-outlet>
  </main>
</div>

<footer-component *ngIf="showFooter$ | async"></footer-component>
